exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.lefttable[data-v-4e85225e]{\n\twidth:64%;\n\tfloat:left;\n}\n.righttable[data-v-4e85225e]{\n\tmax-width:34%;\n\tfloat:right;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4e85225e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/view/View_Contracts.vue
// module id = 562
// module chunks = 0